import { validateSignature } from '@/validators/signature'
import { validateProductPersonChooserLegacy } from '@/validators/product-person-chooser-legacy'

export const VALIDATORS = {
	'product-person-chooser-legacy': validateProductPersonChooserLegacy,
	'signature': validateSignature
}